import { Editor, Transforms } from 'slate';
import { HistoryEditor } from 'slate-history';
import { isTag } from './navigation';
import { findBlockCarrierForTag, relinkPredecessor, removeBlockTagBinding } from './blockTagging';

/**
 * Remove a tag and properly handle continuation chain
 * If tag is in middle of chain, reconnects the chain
 */
export const removeTag = (editor: Editor, tagId: string): void => {
  const entry = Array.from(
    Editor.nodes(editor, {
      at: [],
      match: (n) => isTag(n) && n.tagId === tagId,
    })
  )[0];

  if (!entry) return;

  const [node, path] = entry;

  Editor.withoutNormalizing(editor, () => {
    relinkPredecessor(editor, tagId, isTag(node) ? node.continuedAt : undefined);

    // Unwrap the tag node (removes the tag but keeps the text)
    Transforms.unwrapNodes(editor, { at: path });
  });
};

export const withoutUndo = (editor: HistoryEditor, change: () => void): void => {
  HistoryEditor.withoutSaving(editor, change);
  editor.history = { undos: [], redos: [] };
};

export const unwrapTagMarkers = (editor: Editor, tagIds: Iterable<string>): void => {
  const hasInline = (tagId: string) => Editor.nodes(editor, { at: [], match: (n) => isTag(n) && n.tagId === tagId }).next().done === false;
  Editor.withoutNormalizing(editor, () => {
    for (const tagId of tagIds) {
      while (hasInline(tagId)) removeTag(editor, tagId);
      for (let carrier = findBlockCarrierForTag(editor, tagId); carrier; carrier = findBlockCarrierForTag(editor, tagId)) {
        removeBlockTagBinding(editor, carrier[1], tagId);
      }
    }
  });
};
